import { Modal } from './Modal'

export { Modal }



// WEBPACK FOOTER //
// ./client/Components/Modal/index.js